<template>
  <div class="litigation-stat">
    <!-- 搜索筛选区 -->
    <div class="search-bar">
      <el-form :inline="true" :model="searchForm" size="small">
        <el-form-item label="用户ID">
          <el-input v-model="searchForm.userId" placeholder="请输入用户ID" clearable style="width: 140px;"></el-input>
        </el-form-item>
        <el-form-item label="诉讼单号">
          <el-input v-model="searchForm.litigationNo" placeholder="请输入诉讼单号" clearable style="width: 200px;"></el-input>
        </el-form-item>
        <el-form-item label="订单号">
          <el-input v-model="searchForm.orderNo" placeholder="请输入订单号" clearable style="width: 200px;"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="handleSearch">查询</el-button>
          <el-button icon="el-icon-refresh" @click="handleReset">重置</el-button>
        </el-form-item>
      </el-form>
    </div>

    <!-- 数据表格 -->
    <div class="table-wrap">
      <el-table
        :data="tableData"
        v-loading="loading"
        border
        stripe
        size="small"
        style="width: 100%;"
      >
        <el-table-column prop="id" label="ID" width="70" align="center"></el-table-column>
        <el-table-column prop="litigationNo" label="诉讼单号" min-width="180"></el-table-column>
        <el-table-column prop="orderNo" label="订单号" min-width="180"></el-table-column>
        <el-table-column prop="userId" label="用户ID" width="90" align="center"></el-table-column>
        <el-table-column prop="description" label="诉讼描述" min-width="200" show-overflow-tooltip></el-table-column>
        <el-table-column label="凭证图片" width="90" align="center">
          <template slot-scope="{ row }">
            <template v-if="row.images">
              <el-image
                v-for="(url, idx) in row.images.split(',')"
                :key="idx"
                :src="url.trim()"
                :preview-src-list="row.images.split(',').map(u => u.trim())"
                style="width: 36px; height: 36px; margin-right: 2px; border-radius: 3px;"
                fit="cover"
              ></el-image>
            </template>
            <span v-else class="no-data">—</span>
          </template>
        </el-table-column>
        <el-table-column label="诉讼状态" width="100" align="center">
          <template slot-scope="{ row }">
            <el-tag :type="statusTagType(row.status)" size="mini">{{ statusLabel(row.status) }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="handleUserId" label="处理人ID" width="90" align="center">
          <template slot-scope="{ row }">{{ row.handleUserId || '—' }}</template>
        </el-table-column>
        <el-table-column prop="handleRemark" label="处理备注" min-width="150" show-overflow-tooltip>
          <template slot-scope="{ row }">{{ row.handleRemark || '—' }}</template>
        </el-table-column>
        <el-table-column label="处理时间" width="160" align="center">
          <template slot-scope="{ row }">{{ formatTime(row.handleTime) }}</template>
        </el-table-column>
        <el-table-column label="退款时间" width="160" align="center">
          <template slot-scope="{ row }">{{ formatTime(row.refundTime) }}</template>
        </el-table-column>
        <el-table-column label="创建时间" width="160" align="center">
          <template slot-scope="{ row }">{{ formatTime(row.createTime) }}</template>
        </el-table-column>
        <el-table-column label="操作" width="100" align="center" fixed="right">
          <template slot-scope="{ row }">
            <el-button
              type="primary"
              size="mini"
              :disabled="row.status === 2"
              @click="openHandleDialog(row)"
            >处理</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 处理弹窗 -->
    <el-dialog
      title="处理诉讼"
      :visible.sync="handleDialog.visible"
      width="480px"
      :close-on-click-modal="false"
      @closed="resetHandleForm"
    >
      <el-form :model="handleForm" :rules="handleRules" ref="handleFormRef" label-width="90px" size="small">
        <el-form-item label="诉讼单号">
          <span class="dialog-text">{{ handleDialog.row && handleDialog.row.litigationNo }}</span>
        </el-form-item>
        <el-form-item label="订单号">
          <span class="dialog-text">{{ handleDialog.row && handleDialog.row.orderNo }}</span>
        </el-form-item>
        <el-form-item label="处理方式" prop="status">
          <el-select v-model="handleForm.status" placeholder="请选择处理方式" style="width: 100%;">
            <el-option label="给卖方转账" :value="3"></el-option>
            <el-option label="给买方退款" :value="4"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="处理备注" prop="handleRemark">
          <el-input
            v-model="handleForm.handleRemark"
            type="textarea"
            :rows="4"
            placeholder="请输入处理备注"
            maxlength="500"
            show-word-limit
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button size="small" @click="handleDialog.visible = false">取 消</el-button>
        <el-button type="primary" size="small" :loading="handleDialog.submitting" @click="submitHandle">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 分页 -->
    <div class="pagination-wrap">
      <el-pagination
        background
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        :current-page.sync="pageNumber"
        :page-size.sync="pageSize"
        :page-sizes="[10, 20, 50, 100]"
        @current-change="loadData"
        @size-change="handleSizeChange"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import { axios } from '../../config/axios';

const STATUS_MAP = {
  0: { label: '待处理', type: 'warning' },
  1: { label: '处理中', type: 'primary' },
  2: { label: '已完结', type: 'success' },
};

export default {
  name: 'litigation-stat',
  data() {
    return {
      searchForm: {
        userId: '',
        litigationNo: '',
        orderNo: '',
      },
      tableData: [],
      loading: false,
      total: 0,
      pageNumber: 1,
      pageSize: 10,

      handleDialog: {
        visible: false,
        row: null,
        submitting: false,
      },
      handleForm: {
        status: '',
        handleRemark: '',
      },
      handleRules: {
        status: [{ required: true, message: '请选择处理状态', trigger: 'change' }],
        handleRemark: [{ required: true, message: '请输入处理备注', trigger: 'blur' }],
      },
    };
  },

  created() {
    this.loadData();
  },

  methods: {
    loadData() {
      this.loading = true;
      const params = {
        pageNumber: this.pageNumber,
        pageSize: this.pageSize,
      };
      if (this.searchForm.userId) params.userId = this.searchForm.userId;
      if (this.searchForm.litigationNo) params.litigationNo = this.searchForm.litigationNo;
      if (this.searchForm.orderNo) params.orderNo = this.searchForm.orderNo;

      axios.get('admin//order/litigation', { params })
        .then(res => {
          if (res.code === 200) {
            this.tableData = res.data.list || [];
            this.total = res.data.total || 0;
          } else {
            this.$message.error(res.message || '查询失败');
          }
        })
        .catch(() => {
          this.$message.error('请求失败，请稍后重试');
        })
        .finally(() => {
          this.loading = false;
        });
    },

    handleSearch() {
      this.pageNumber = 1;
      this.loadData();
    },

    handleReset() {
      this.searchForm = { userId: '', litigationNo: '', orderNo: '' };
      this.pageNumber = 1;
      this.loadData();
    },

    handleSizeChange() {
      this.pageNumber = 1;
      this.loadData();
    },

    statusLabel(status) {
      return (STATUS_MAP[status] || { label: '未知' }).label;
    },

    statusTagType(status) {
      return (STATUS_MAP[status] || { type: 'info' }).type;
    },

    formatTime(timeStr) {
      if (!timeStr) return '—';
      const date = new Date(timeStr);
      if (isNaN(date.getTime())) return timeStr;
      const pad = n => String(n).padStart(2, '0');
      return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
    },

    openHandleDialog(row) {
      this.handleDialog.row = row;
      this.handleForm.status = row.status === 0 ? 1 : row.status;
      this.handleForm.handleRemark = row.handleRemark || '';
      this.handleDialog.visible = true;
    },

    resetHandleForm() {
      this.handleForm = { status: '', handleRemark: '' };
      this.handleDialog.row = null;
      if (this.$refs.handleFormRef) {
        this.$refs.handleFormRef.clearValidate();
      }
    },

    submitHandle() {
      this.$refs.handleFormRef.validate(valid => {
        if (!valid) return;
        this.handleDialog.submitting = true;
        const row = this.handleDialog.row;
        axios.post(`admin/order/litigation/handle`, {
          status: this.handleForm.status,
          handleRemark: this.handleForm.handleRemark,
          litigationNo: row.litigationNo,
          orderNo: row.orderNo,
        }, {
          headers: { 'Content-Type': 'application/json' },
          transformRequest: [(data) => JSON.stringify(data)],
        }).then(res => {
          if (res.code === 200) {
            this.$message.success('处理成功');
            this.handleDialog.visible = false;
            this.loadData();
          } else {
            this.$message.error(res.message || '处理失败');
          }
        }).catch(() => {
          this.$message.error('请求失败，请稍后重试');
        }).finally(() => {
          this.handleDialog.submitting = false;
        });
      });
    },
  },
};
</script>

<style scoped>
.litigation-stat {
  padding: 20px;
  background: #fff;
  border-radius: 8px;
  min-height: 400px;
}

.search-bar {
  margin-bottom: 16px;
  padding-bottom: 16px;
  border-bottom: 1px solid #f0f2f5;
}

.table-wrap {
  margin-bottom: 16px;
}

.pagination-wrap {
  display: flex;
  justify-content: flex-end;
}

.no-data {
  color: #c0c4cc;
}

.dialog-text {
  color: #606266;
  font-size: 13px;
}
</style>
